export const MIN_ZOOM_LEVEL = 16;
export const MAX_ZOOM_LEVEL = 22;
